var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{staticClass:"scrollable h20"},[(_vm.loading)?_c('Loader'):_vm._e(),_c('v-img',{staticClass:"img",attrs:{"width":_vm.width,"src":_vm.source},on:{"load":function($event){_vm.loading = false},"error":function($event){_vm.loading = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }